var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStackedBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1020_14952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3014 2.85425H0.357056V10.7542H10.3014V2.85425Z",
    fill: "#003F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1923 2.85425H31.5263C31.6547 2.85425 31.7779 2.90693 31.8687 3.00069C31.9595 3.09446 32.0105 3.22164 32.0105 3.35425V10.2142C32.0105 10.3469 31.9595 10.474 31.8687 10.5678C31.7779 10.6616 31.6547 10.7142 31.5263 10.7142H11.1923V2.85425V2.85425Z",
    fill: "#0298A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6163 15.7743H29.0765C29.2049 15.7743 29.3281 15.827 29.4189 15.9207C29.5096 16.0145 29.5607 16.1417 29.5607 16.2743V23.2143C29.5607 23.3469 29.5096 23.4741 29.4189 23.5678C29.3281 23.6616 29.2049 23.7143 29.0765 23.7143H19.6163V15.8143V15.7743Z",
    fill: "#0298A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6093 15.7743H0.357056V23.6743H18.6093V15.7743Z",
    fill: "#003F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5863 28.6942H0.357056V36.5942H23.5863V28.6942Z",
    fill: "#003F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5546 28.6942H39.6308C39.7592 28.6942 39.8824 28.7469 39.9732 28.8407C40.064 28.9344 40.115 29.0616 40.115 29.1942V36.0942C40.115 36.2268 40.064 36.354 39.9732 36.4478C39.8824 36.5415 39.7592 36.5942 39.6308 36.5942H24.5546V28.6942V28.6942Z",
    fill: "#0298A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.357056 0.214233L0.482932 40.2142",
    stroke: "#2B2B35",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1020_14952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.11499 0.214233)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedBar);
export default __webpack_public_path__ + "static/media/stacked_bar.6de550fcc180230613d7febd1ed8e050.svg";
export { ForwardRef as ReactComponent };